// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs-module--breadcrumbs--3qwVR","breadcrumbs__content":"Breadcrumbs-module--breadcrumbs__content--2o93s"};